import { apiCall } from "./service";
import { URL_EXPORT } from "./URL";

export const api = {

  getExport(params) {
    const queryParams = Object.entries(params)
      .filter(([_, value]) => value !== null && value !== undefined)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");

    const url = `${URL_EXPORT}${queryParams ? `?${queryParams}` : ""}`;
    return apiCall.getFile({
      url,
      headers: {
        Accept:
          "text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "Content-Type": "blob",
      },
      responseType: "arraybuffer",
    });
  },

  getTimesheetExport(params) {
    const queryParams = Object.entries(params)
      .filter(([_, value]) => value !== null && value !== undefined && value !== "")
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");

    const url = `${URL_EXPORT}/timesheets${queryParams ? `?${queryParams}` : ""}`;
    return apiCall.getFile({
      url,
      headers: {
        Accept:
          "text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "Content-Type": "blob",
      },
      responseType: "arraybuffer",
    });
  },
};

export default api;
